import {
  ApolloClient,
  QueryOptions,
  MutationOptions,
  SubscriptionOptions,
  WatchQueryOptions
} from "@apollo/client";
import omitDeep from "deepdash/omitDeep";

const getVariables = (v: any) => omitDeep(v, ["__typename"]);

export function query<V, R>(doc: any, getClient: () => ApolloClient<any>) {
  return {
    func: (variables: V, options: Partial<QueryOptions<V>> = {}) =>
      getClient().query<R, V>({
        query: doc,
        fetchPolicy:
          process.env["NODE_ENV"] === "test" ? "no-cache" : options.fetchPolicy,
        variables: getVariables(variables),
        ...options
      }),
    /**
     * REMEMBER TO UNSUBSCRIBE
     */
    funcWatch: (variables: V, options: Partial<WatchQueryOptions<V>> = {}) =>
      getClient().watchQuery<R, V>({
        query: doc,
        variables: getVariables(variables),
        ...options
      })
  };
}
export function mutation<V, R>(doc: any, getClient: () => ApolloClient<any>) {
  return {
    func: (variables: V, options: Partial<MutationOptions<R, V>> = {}) =>
      getClient().mutate<R, V>({
        mutation: doc,
        variables: getVariables(variables),
        ...options
      })
  };
}
export function subscription<V, R>(doc: any, getClient: () => ApolloClient<any>) {
  return {
    /**
     * REMEMBER TO UNSUBSCRIBE
     */
    func: (variables: V, options: Partial<SubscriptionOptions<V>> = {}) =>
      getClient().subscribe<R, V>({
        query: doc,
        variables: getVariables(variables),
        ...options
      })
  };
}
